import { render, staticRenderFns } from "./MensageriaLote.vue?vue&type=template&id=778ff896&scoped=true"
import script from "./MensageriaLote.vue?vue&type=script&lang=js"
export * from "./MensageriaLote.vue?vue&type=script&lang=js"
import style0 from "./MensageriaLote.vue?vue&type=style&index=0&id=778ff896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ff896",
  null
  
)

export default component.exports